const state = {
    activeLink: "windzone",
    activeTrigger: 0,
    activeContent: "windzone"
}

// getters
const getters = {
    getActiveLink: (state) => state.activeLink,
    getActiveTrigger: (state) => state.activeTrigger,
    getActiveContent: (state) => state.activeContent,
}

// actions
const actions = {
    changeActiveLink({commit}, link)
    {
        commit("setActiveLink", link)
    },
    incrementTrigger({commit})
    {
        commit("incrementActiveTrigger")
    },
    changeActiveContent({commit}, content)
    {
        commit("setActiveContent", content)
    }
}

// mutations
const mutations = {
    setActiveLink: (state, link) => {state.activeLink = link},
    setActiveContent: (state, content) => {
        if(content != "dach")
            state.activeContent = content
        else
            state.activeContent = "gebaeude"
    },
    incrementActiveTrigger: (state) => {state.activeTrigger++}
}

export default {
    state,
    getters,
    actions,
    mutations
}